import React from 'react'
import '../style/page_02.scss'
import { format } from '../config'
function Page02(props) {
  const lineWidth = [0, 54, 244, 438, 630, 710];
  const level = Math.floor(props.totalCount / 50000) > 5 ? 5 : Math.floor(props.totalCount / 50000);
  const extraTotalLength = level === 0 ? 20 : (lineWidth[level + 1] - lineWidth[level]);
  const extraLength = extraTotalLength * ((props.totalCount % 50000) / 50000);
  const totalLength = level === 5 ? 710 : extraLength + lineWidth[level];
  return (
    <div className="page page_02">
      <div className="title"></div>
      <div className="current-count-container">
        <p>当前预约人数</p>
        <p className="current-count">{format(props.totalCount)}</p>
      </div>
      <div className="progress-container">
        <div className="progress-line-container">
          <div className="line-container">
            <div className="solid-line" style={{ 'width': totalLength + 'px' }}></div>
            <div className="gradient-line"></div>
          </div>
        </div>
        <ul className="item-list">
          {[0, 1, 2, 3].map((index) => (
            <li className={index < props.level ? 'active' : ''} key={index.toString()}>
              <div className="point">
                <div className="inner"></div>
                <div className="num"></div>
              </div>
              <div className="item-container">
                <div></div>
                <div></div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Page02;
